import React, { ReactElement } from 'react';
import { observer } from 'mobx-react-lite';
import {
  RouteID,
  RouteView,
} from '../../../../infrastructure/types/features/navigation/navigation-types';
import { useRouterLogic } from '../hooks/logic';
import { AuthLayout } from '../../../layouts/AuthLayout';
import { HomePage } from '../../../pages/HomePage';
import { LoginPage } from '../../../pages/LoginPage';
import { RegisterPage } from '../../../pages/RegisterPage';
import { RegisterEmailPage } from '../../../pages/RegisterEmailPage';
import { RegisterPhonePage } from '../../../pages/RegisterPhonePage';
import { RecoveryRequestPage } from '../../../pages/RecoveryRequestPage';
import { RecoveryResetPage } from '../../../pages/RecoveryResetPage';
import { InvitationPage } from '../../../pages/InvitationPage';
import { TemporaryAuthPage } from '../../../pages/TemporaryAuthPage';
import { AuthWrapper } from '../../auth/AuthWrapper';

interface RouterProps {}

interface RouterLogic {
  currentView: RouteView | null;
}

let Router = function ({}: RouterProps): ReactElement {
  const { currentView } = useRouterLogic();

  const renderPage = () => {
    if (!currentView) return null;

    switch (currentView.id) {
      case RouteID.ROOT:
        return <HomePage />;

      case RouteID.LOGIN:
        return <AuthWrapper />;

      case RouteID.REGISTER:
        return <AuthWrapper />;

      case RouteID.REGISTER_EMAIL:
        return <RegisterEmailPage />;

      case RouteID.REGISTER_PHONE:
      case RouteID.REGISTER_PHONE_PARAM:
        return <RegisterPhonePage phone={currentView.params?.phone} />;

      case RouteID.RECOVERY:
        return <RecoveryRequestPage />;

      case RouteID.RECOVERY_RESET:
        return (
          <RecoveryResetPage
            resetPasswordToken={currentView.params?.resetPasswordToken}
            email={currentView.params?.recoveryEmail}
          />
        );

      case RouteID.INVITATIONS:
        return (
          <InvitationPage
            invitationToken={currentView.params?.invitationToken}
            email={currentView.params?.invitationEmail}
          />
        );

      case RouteID.TEMPORARY_SIGN_IN:
        return <TemporaryAuthPage token={currentView.params?.token} />;

      case RouteID.NOT_FOUND:
      default:
        return <HomePage />;
    }
  };

  return <AuthLayout>{renderPage()}</AuthLayout>;
};

Router = observer(Router);

export { Router, type RouterLogic };
